module.exports = __webpack_public_path__ + "static/post_small-8393ea13d1def507ea64fa952f89dd4e.svg";